import module from 'viaticos/module.js'
import template from './template.html'
import * as moment from 'moment'

export class ViaticosViaticoSeguimientoComponent {
  mostrar = false
  onLoad
  seleccionado = null
  viaticoId

  constructor (ViaticosViaticoSeguimientoService) {
    this.ViaticosViaticoSeguimientoService = ViaticosViaticoSeguimientoService
  }

  $onInit () {
    this.promise = this.ViaticosViaticoSeguimientoService.get(this.viaticoId)
      .then(({data}) => {
        this.data = data
        if (this.data && !this.data.pendiente) {
          this.onLoad({$event: {detail: {total_detalles: this.data.total_detalles, total_solicitudes: this.data.total_solicitudes}}})
        }
      })
  }

  seleccionar (item) {
    this.seleccionado = this.seleccionado === item ? null : item
  }

  changeMostrar () {
    this.mostrar = !this.mostrar
  }
}

module.component('viaticosViaticoSeguimiento', {
  controller: ViaticosViaticoSeguimientoComponent,
  template,
  bindings: {
    viaticoId: '<',
    onLoad: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/viatico/seguimiento/component.js